import deepExtend from 'deep-extend'
import defaults from './modes/defaults'
import test from './modes/test'
import development from './modes/development'
import * as helpers from './helpers'
import accp from './modes/accp.js'
import testruimte from './modes/testruimte.js'
import prod from './modes/prod.js'

const config = {
    defaults: {
        ...helpers.createConfigSection('env', {
            public_path: import.meta.env.PUBLIC_PATH,
            mode: import.meta.env.MODE || 'development',
            isBrowser: typeof window !== 'undefined',
            isDev: import.meta.env.NODE_ENV !== 'production'
        }),

        ...defaults
    },
    test,
    accp,
    testruimte,
    prod,
    development
}

const externalConfig = window.AATUI_CONFIG || {}

const completeConfig = deepExtend({}, config.defaults, config[config.defaults.env_mode], externalConfig)

export function getConfigSection(section) {
    return helpers.getConfigSection(completeConfig, section)
}

export function getConfig(key) {
    return helpers.getConfig(completeConfig, key)
}
